export default function CheckUserAuth(){
   var  res= localStorage.getItem("token");
    if(res==null){
        return false;
    }
    else{
        return true;
    }
}